import "core-js/modules/es.object.to-string";
import _classCallCheck from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/aurel/hubo-front/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module upload/adapters/base64uploadadapter
 */

/* globals window */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileRepository from '../filerepository';
/**
 * A plugin that converts images inserted into the editor into [Base64 strings](https://en.wikipedia.org/wiki/Base64)
 * in the {@glink installation/advanced/saving-data editor output}.
 *
 * This kind of image upload does not require server processing – images are stored with the rest of the text and
 * displayed by the web browser without additional requests.
 *
 * Check out the {@glink features/images/image-upload/image-upload comprehensive "Image upload overview"} to learn about
 * other ways to upload images into CKEditor 5.
 *
 * @extends module:core/plugin~Plugin
 */

var Base64UploadAdapter = /*#__PURE__*/function (_Plugin) {
  _inherits(Base64UploadAdapter, _Plugin);

  var _super = _createSuper(Base64UploadAdapter);

  function Base64UploadAdapter() {
    _classCallCheck(this, Base64UploadAdapter);

    return _super.apply(this, arguments);
  }

  _createClass(Base64UploadAdapter, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      this.editor.plugins.get(FileRepository).createUploadAdapter = function (loader) {
        return new Adapter(loader);
      };
    }
  }], [{
    key: "requires",

    /**
     * @inheritDoc
     */
    get: function get() {
      return [FileRepository];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'Base64UploadAdapter';
    }
  }]);

  return Base64UploadAdapter;
}(Plugin);
/**
 * The upload adapter that converts images inserted into the editor into Base64 strings.
 *
 * @private
 * @implements module:upload/filerepository~UploadAdapter
 */


export { Base64UploadAdapter as default };

var Adapter = /*#__PURE__*/function () {
  /**
   * Creates a new adapter instance.
   *
   * @param {module:upload/filerepository~FileLoader} loader
   */
  function Adapter(loader) {
    _classCallCheck(this, Adapter);

    /**
     * `FileLoader` instance to use during the upload.
     *
     * @member {module:upload/filerepository~FileLoader} #loader
     */
    this.loader = loader;
  }
  /**
   * Starts the upload process.
   *
   * @see module:upload/filerepository~UploadAdapter#upload
   * @returns {Promise}
   */


  _createClass(Adapter, [{
    key: "upload",
    value: function upload() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var reader = _this.reader = new window.FileReader();
        reader.addEventListener('load', function () {
          resolve({
            default: reader.result
          });
        });
        reader.addEventListener('error', function (err) {
          reject(err);
        });
        reader.addEventListener('abort', function () {
          reject();
        });

        _this.loader.file.then(function (file) {
          reader.readAsDataURL(file);
        });
      });
    }
    /**
     * Aborts the upload process.
     *
     * @see module:upload/filerepository~UploadAdapter#abort
     * @returns {Promise}
     */

  }, {
    key: "abort",
    value: function abort() {
      this.reader.abort();
    }
  }]);

  return Adapter;
}();